import { memo } from "react";
import "./CSS/conversation.css";
import DesktopConversationBody from "./Desktop/DesktopConversationBody";
import MobileConversationBody from "./Mobile/MobileConversationBody";

const ConversationBody = () => {
  console.log("");
  return (
    <>
      <div className="conversation-desktop">
        <DesktopConversationBody />
      </div>
      <div className="conversation-mobile">
        <MobileConversationBody />
      </div>

    </>
  );
};

export default memo(ConversationBody);
